import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import "./form-item-life-cover-insurance-v2.component.scss";
var FormItemLifeCoverInsuranceV2 = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemLifeCoverInsuranceV2, _super);
    function FormItemLifeCoverInsuranceV2(element) {
        var _this = _super.call(this, element) || this;
        _this.gRecaptchaToken = '';
        return _this;
    }
    FormItemLifeCoverInsuranceV2.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.submitBtn = this.element.querySelector(".js-life-cover-insurance-v2__button");
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector(".form-container__error");
        }
        this.showMoreBtn = this.element.querySelector(".data-privacy-collapse-show");
        this.showLessBtn = this.element.querySelector(".data-privacy-collapse-hide");
        this.dataPrivacyDetailArea = this.element.querySelector(".data-privacy-detail");
        this.dataSharingGroupHideBtn = this.element.querySelector(".data-sharing-group-hide-btn");
        this.dataSharingGroupShowBtn = this.element.querySelector(".data-sharing-group-show-btn");
        this.dataSharingGroupTextArea = this.element.querySelector(".data-sharing-group");
        this.dataSharing3rdPartyShowBtn = this.element.querySelector(".data-sharing-3rd-party-show-btn");
        this.dataSharing3rdPartyHideBtn = this.element.querySelector(".data-sharing-3rd-party-hide-btn");
        this.dataSharing3rdPartyTextArea = this.element.querySelector(".data-sharing-3rd-party");
        this.dataSharingBoardersHideBtn = this.element.querySelector(".data-sharing-boarders-hide-btn");
        this.dataSharingBoardersShowBtn = this.element.querySelector(".data-sharing-boarders-show-btn");
        this.dataSharingBoardersTextArea = this.element.querySelector(".data-sharing-boarders");
    };
    FormItemLifeCoverInsuranceV2.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.showDisplayView("loader");
                // Check if gRecaptcha is enabled for this form
                if (grecaptcha != null && _this.formsService.getGRecaptchaSiteKey() != '') {
                    var gToken_1 = '';
                    try {
                        // Attempt to get recaptcha token
                        grecaptcha.enterprise.ready(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var err_1;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, grecaptcha.enterprise.execute(this.formsService.getGRecaptchaSiteKey(), { action: 'LOGIN' })];
                                    case 1:
                                        gToken_1 = _a.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        err_1 = _a.sent();
                                        // Log error
                                        console.log("Unable to retrieve gRecaptcha Token");
                                        console.log(err_1);
                                        return [3 /*break*/, 3];
                                    case 3:
                                        // Set recaptcha token
                                        this.gRecaptchaToken = gToken_1;
                                        this.submitForm(_form);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    }
                    catch (err) {
                        // Log error
                        console.log("Unable to retrieve gRecaptcha Token");
                        console.log(err);
                        _this.submitForm(_form);
                    }
                }
                else {
                    _this.submitForm(_form);
                }
            }
        });
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.showLessBtn.setAttribute("hidden", "true");
                _this.showMoreBtn.removeAttribute("hidden");
                _this.dataPrivacyDetailArea.setAttribute("hidden", "true");
            });
        }
        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.showMoreBtn.setAttribute("hidden", "true");
                _this.showLessBtn.removeAttribute("hidden");
                _this.dataPrivacyDetailArea.removeAttribute("hidden");
            });
        }
        if (this.dataSharingGroupHideBtn) {
            this.dataSharingGroupHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.setAttribute("hidden", "true");
                _this.dataSharingGroupHideBtn.setAttribute("hidden", "true");
                _this.dataSharingGroupShowBtn.removeAttribute("hidden");
            });
        }
        if (this.dataSharingGroupShowBtn) {
            this.dataSharingGroupShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.removeAttribute("hidden");
                _this.dataSharingGroupHideBtn.removeAttribute("hidden");
                _this.dataSharingGroupShowBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharing3rdPartyHideBtn) {
            this.dataSharing3rdPartyHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.setAttribute("hidden", "true");
                _this.dataSharing3rdPartyShowBtn.removeAttribute("hidden");
                _this.dataSharing3rdPartyHideBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharing3rdPartyShowBtn) {
            this.dataSharing3rdPartyShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.removeAttribute("hidden");
                _this.dataSharing3rdPartyHideBtn.removeAttribute("hidden");
                _this.dataSharing3rdPartyShowBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharingBoardersShowBtn) {
            this.dataSharingBoardersShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.removeAttribute("hidden");
                _this.dataSharingBoardersShowBtn.setAttribute("hidden", "true");
                _this.dataSharingBoardersHideBtn.removeAttribute("hidden");
            });
        }
        if (this.dataSharingBoardersHideBtn) {
            this.dataSharingBoardersHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.setAttribute("hidden", "true");
                _this.dataSharingBoardersHideBtn.setAttribute("hidden", "true");
                _this.dataSharingBoardersShowBtn.removeAttribute("hidden");
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.showDisplayView("");
        }, false);
    };
    FormItemLifeCoverInsuranceV2.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemLifeCoverInsuranceV2.prototype.submitForm = function (pForm) {
        var _this = this;
        var _campaignName = pForm.querySelector("input[name=campaignName]");
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _lastName = this.form.querySelector("input[name=last-name]");
        var _contact = this.form.querySelector("input[name=contact-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _popiaConsent = this.form.querySelector("input[name=popia-consent]");
        var _postData = {
            compaignname: _campaignName ? _campaignName.value : "",
            firstname: _firstname ? _firstname.value : "",
            lastname: _lastName ? _lastName.value : "",
            contact: _contact ? _contact.value : "",
            email: _emailAddress ? _emailAddress.value : "",
            popiaConsent: _popiaConsent
                ? _popiaConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            dataPrivacyConsent: _popiaConsent
                ? _popiaConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            dataSharingWithinOurGrpMarketingConsent: this.getDataConsentValue(this.form, "data-sharing-group"),
            dataSharingWithThirdPartiesMarketingConsent: this.getDataConsentValue(this.form, "data-sharing-3rd-party"),
            dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.getDataConsentValue(this.form, "data-sharing-boarders"),
            recaptchaToken: this.gRecaptchaToken
        };
        var consentsParams = {
            firstName: _firstname ? _firstname.value : "",
            lastName: _lastName ? _lastName.value : "",
            identificationNumber: "",
            passportNumber: "",
            emailAddress: _emailAddress ? _emailAddress.value : "",
            contactNumber: _contact ? _contact.value : "",
            altContactNumber: "",
            product: _campaignName ? _campaignName.value : "",
            dataPrivacyConsent: _popiaConsent
                ? _popiaConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            dataSharingWithinOurGrpMarketingConsent: this.getDataConsentValue(this.form, "data-sharing-group"),
            dataSharingWithThirdPartiesMarketingConsent: this.getDataConsentValue(this.form, "data-sharing-3rd-party"),
            dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.getDataConsentValue(this.form, "data-sharing-boarders"),
            marketingConsents: "",
        };
        this.showDisplayView("loader");
        // variables
        var url = this.baseUrl + "/pbbsaleads/dfs/create";
        // config
        var _config = {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
            },
        };
        var consentURL = this.baseUrl + "/leadsutils/createpcm";
        // service
        this.formsService
            .postForm(url, _postData, _config)
            .then(function (pResponse) {
            if (!pResponse) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else if (!pResponse.data || String(pResponse.data).match(/invalid/gi) || String(pResponse.data).match(/error/gi) || String(pResponse.data).match(/503/gi)) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else if (pResponse.data.leadid || pResponse.data.leadnumber) {
                _this.analyticsService.dtmFormComplete("complete", pResponse.code, false, "", _emailAddress.value, _contact.value);
                _this.showDisplayView("success");
                if (_this.form.getAttribute("data-frmcontainer") &&
                    (_this.form
                        .getAttribute("data-frmcontainer")
                        .includes("salary") ||
                        _this.form
                            .getAttribute("data-frmcontainer")
                            .includes("disability") ||
                        _this.form
                            .getAttribute("data-frmcontainer")
                            .includes("illness") ||
                        _this.form
                            .getAttribute("data-frmcontainer")
                            .includes("insurance life cover"))) {
                    _this.formsService
                        .postForm(consentURL, consentsParams, _config)
                        .then(function (pResponse) { });
                }
            }
            else {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
        })
            .catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemLifeCoverInsuranceV2.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    return FormItemLifeCoverInsuranceV2;
}(Base));
export { FormItemLifeCoverInsuranceV2 };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-life-cover-insurance-v2/form-item-life-cover-insurance-v2.component.ts
// module id = 941
// module chunks = 0